import './App.css';
import logoB from './components/images/logoB.png'
import logoL from './components/images/logoLaranja.png';
import { Link, Route, Routes, useLocation } from 'react-router-dom'
import React, { useEffect, useState, useRef} from 'react'
import useWaypointAnimation from './hooks/useWaypointAnimation'
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import Homepage from './components/pages/Homepage';
import Navbar from './components/pages/Navbar';
function App() {
  const { t, i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(null);
  const languages = [
  { code: 'es', name: 'Español', flag: 'https://cdn.countryflags.com/thumbs/spain/flag-800.png' },
  { code: 'pt', name: 'Português', flag: 'https://cdn.countryflags.com/thumbs/portugal/flag-800.png' },
  { code: 'en', name: 'English', flag: 'https://cdn.countryflags.com/thumbs/england/flag-800.png' },
  { code: 'fr', name: 'Français', flag: 'https://cdn.countryflags.com/thumbs/france/flag-800.png' },
  { code: 'zh', name: '中文', flag: 'https://cdn.countryflags.com/thumbs/china/flag-800.png' },
  { code: 'it', name: 'Italiano', flag: 'https://cdn.countryflags.com/thumbs/italy/flag-800.png' },
  { code: 'de', name: 'Deutsch', flag: 'https://cdn.countryflags.com/thumbs/germany/flag-800.png' }
];
  // Função para mudar o idioma
  useEffect(() => {
    const currentLang = languages.find(l => l.code === i18n.language);
    setSelectedLang(currentLang);

    // Salva o idioma atual no localStorage
    // Isso garante que ele persista após o recarregamento
    localStorage.setItem('i18nextLng', i18n.language);
  }, [i18n.language]);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
<div className="App">
  <Navbar />

<footer id='contacts'>
  <div className="container">
    <div className="row">
      <div className="col" id="company">
        <img src={logoL} alt="logo" className="logo" />
        <p>{t('footer.iberolec')}</p>
        <div className="footer-text">
            <p><Link to='/politica-de-privacidade'>{t('footer.poliPri')}</Link></p>
            <p><Link to='/politica-de-cookies'>{t('footer.poliCookie')}</Link></p>
        </div>
        {/*
        <div className="social">
          <a href="#">
            <i className="fab fa-facebook" />
          </a>
          <a href="#">
            <i className="fab fa-instagram" />
          </a>
          <a href="#">
            <i className="fab fa-linkedin" />
          </a>
        </div>
        */}
      </div>
      <div className="col" id="useful-links">
        <h3>{t('footer.horario')}</h3>
        <div className="links">
        <ul>
            {t('footer.diasuteis')}
            <br/>09:00 {t('navbar.ate')} 14h - 16.00 {t('navbar.ate')} 19:00<br/><br/>
            {t('footer.fsemana')}<br/>
            {t('footer.encerrado')}
        </ul>
        </div>
      </div>
      <div className="col" id="contact">
        <h3>{t('footer.contactar')}</h3>
        <div className="contact-details">
          <i className="fa fa-location" />
          <p> C. Murias, 27 C, <br /> {t('footer.cidade')}, {t('footer.pais')}</p>
        </div>
        <div className="contact-details">
          <i className="fa-solid fa-mobile-screen-button"></i>
          <a href="tel:+34696464669" className="sidebarItem" data-tooltip="Contacto" type="tel"><p>+34 696464669</p></a>
        </div>
        <div className="contact-details">
          <i className="fa fa-phone" />
           <a href="tel:+34916346239" className="sidebarItem" data-tooltip="Contacto"><p>+34 916346239</p></a>
        </div>
        <div className="contact-details">
          <i className="fa fa-envelope" />
          <a href="mailto:geral@iberolec.com" className="sidebarItem" data-tooltip="Email"><p>info@iberolec.com</p></a>
        </div>
      </div>
      <div className="col" id="languages">
        <h3>{t('footer.idiomas')}</h3>
        <div className="links">
        <div className="dropdown">
        <button className="btn dropdown-toggle d-flex align-items-center" type="button" data-bs-toggle="dropdown"  aria-expanded="false">
        {selectedLang ? (
          <>
            <img src={selectedLang.flag} alt={`Flag of ${selectedLang.name}`} width="20" className="me-2" />
            {selectedLang.name}
          </>
        ) : (
          'Selecione o idioma'
        )}
          </button>
        <ul className="dropdown-menu">
        {languages.map(lang => (
          <li key={lang.code}>
            <button className="dropdown-item d-flex align-items-center" onClick={() => handleLanguageChange(lang.code)}>
              <img src={lang.flag} alt={`Flag of ${lang.name}`} width="20" className="me-2" />
              {lang.name}
            </button>
          </li>
        ))}
          </ul>
        </div>
        </div>
      </div>
    </div>
  </div>
</footer>
  </div>
  );
}

export default App;
